module.exports = __webpack_public_path__ + "img/find-hospital.3ab4fa63.svg";